import KeyMetric from '@/pages/CompanyReport/components/Overview/components/Header/components/KeyMetric';
import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';

type Props = {
  onClick: () => void;
};

export const DefaultState = ({ onClick }: Props) => {
  return (
    <KeyMetric
      type="Metric"
      testId="my-fair-value"
      title="My Fair Value"
      metric={
        <span
          className="grid gap-1 grid-cols-[max-content_max-content] cursor-pointer items-center"
          onClick={onClick}
        >
          <span className="m-0 text-xs text-accent">Select narrative</span>
          <PencilOutline className="w-x2 h-x2 fill-accent" />
        </span>
      }
    />
  );
};
